if (typeof window !== "undefined") {
    const { fetch: originalFetch } = window;
    window.fetch = async (...args) => {
        console.log("interceptor");
        let [resource, config] = args;
        
        // Create config object if it doesn't exist
        if (!config) {
            config = {};
        }
        
        // Add credentials: 'include' if not already set
        if (!config.credentials) {
            config.credentials = 'include';
        }
        
        return originalFetch(resource, config);

    };
}